export const CART_ITEMS_TAB_ID = "PO-Items";
export const CART_APPROVERS_TAB_ID = "PO-Approvers";
export const CART_ATTACHMENTS_TAB_ID = "PO-Attachments";
export const CART_COMMENTS_TAB_ID = "PO-Comments";